import { NORMALIZATION } from "helpers/segments"

export function canSegmentBeDisplayed(positionSet, isActive) {
  if (positionSet) {
    if (isActive && positionSet.segment && positionSet.segment.normalization !== NORMALIZATION.STANDALONE) {
      return false
    }
    return true
  }
  return false
}
